// Third-party
import React from 'react';

// Components
import ModalV2 from '@/views/components/modals/ModalV2';
import { PlanAccountsTable } from '@/views/containers/planning/data-tables/PlanAccountsTable';
import { AccountColumns } from '@/views/containers/planning/data-tables/plan-accounts-table/useAccountColumnsDefinition';
import LoadingScreen from '@/views/components/common/LoadingScreen';

// Utils
import { MODAL_SIZES } from '@/utils/constants';

// Types
import Contact from '@/types/contact';
import { useContactPlanAccounts } from '@/hooks/planning/useContactPlanAccounts';
import { formatMessage } from '@/utils/i18n';

type Props = {
  show: boolean;
  contact: Contact;
  planId?: string;
  selectedPlanAccountId?: string;
  onClose: () => void;
  onSelectPlanAccount: (planAccountId: string) => any;
};

const i18nBasePath = 'PortfolioEditorBuilder.PlanAccount';

const PortfolioEditorPlanAccountModal = ({ show, contact, selectedPlanAccountId, onClose, onSelectPlanAccount }: Props) => {
  const { isLoading, importedAccounts, error } = useContactPlanAccounts({ contact, skip: !contact._id || !show, selectedPlanAccountId });

  return (
    <ModalV2
      show={show}
      title={`${i18nBasePath}.ContactsPlanAccount`}
      titleI18nParams={{ name: contact.fname }}
      modalClassName="portfolio-editor-plan-account-modal"
      body={
        <>
          {isLoading && <LoadingScreen titleToLocalize={`${i18nBasePath}.Loading.GetPlanForContact.Title`} />}
          {!isLoading && !error && (
            <div className="table-container">
              <PlanAccountsTable
                columns={[
                  AccountColumns.NAME,
                  AccountColumns.LINKED_PORTFOLIO,
                  AccountColumns.TOTAL_VALUE,
                  AccountColumns.RISK_PROFILE,
                  AccountColumns.TARGET_RATE_OF_RETURN,
                  AccountColumns.ACTION_SELECT_PLAN_ACCOUNT,
                ]}
                data={importedAccounts}
                buttonActions={{ onSelectPlanAccount }}
                i18nBasePath={i18nBasePath}
                isSelectable={false}
                selectedPlanAccountId={selectedPlanAccountId}
              />
            </div>
          )}
          {!isLoading && error && (
            <div className="error-state">
              <p>{formatMessage(`${i18nBasePath}.Error.LoadingPlanAccounts`)}</p>
            </div>
          )}
        </>
      }
      onClose={onClose}
      size={MODAL_SIZES.XL}
      defaultFooterButtons={{
        cancelLabelToLocalize: 'Common.Cancel',
        cancelOnClick: onClose,
      }}
    />
  );
};

export default PortfolioEditorPlanAccountModal;
